import React, { useState, useEffect } from 'react'
import styles from './layout.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { ACTION, ROUTES } from 'consts'
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { Bell, CarretDown } from 'utils/icon'
import jwt_decode from 'jwt-decode'
import { useTranslation } from 'react-i18next'

//components
import DropdownLanguage from 'components/dropdown-language'
import { PERMISSIONS } from 'consts'
import Permission from 'components/permission'

//antd
import {
  Layout,
  Menu,
  Dropdown,
  BackTop,
  Affix,
  Avatar,
  Badge,
  Empty,
  Row,
  Col,
  Input,
  notification,
  Form,
  Modal,
} from 'antd'

//icons
import {
  MenuOutlined,
  LogoutOutlined,
  FormOutlined,
  UserOutlined,
  TableOutlined,
  ExportOutlined,
  SlidersOutlined,
  FileSearchOutlined,
  CreditCardOutlined,
  UsergroupAddOutlined,
  ShoppingCartOutlined,
  AppstoreAddOutlined,
  TagOutlined,
  BranchesOutlined,
  LockOutlined,
  GlobalOutlined,
  FolderViewOutlined,
  PartitionOutlined,
  GiftOutlined,
  DollarCircleOutlined,
  TagsOutlined,
  AliwangwangOutlined,
} from '@ant-design/icons'
import logoApp from 'assets/img/logo-app.png'
import IconEmailManager from 'assets/icons/icon-email-manager.svg'

//apis
import { apiSearch } from 'apis/user'
import { resetPassword } from 'apis/customer'

const { Sider } = Layout
const BaseLayout = (props) => {
  const history = useHistory()
  const { t } = useTranslation()
  const location = useLocation()
  const routeMatch = useRouteMatch()
  const WIDTH_MENU_OPEN = 230
  const WIDTH_MENU_CLOSE = 60

  const dataUser = useSelector((state) => state.login.dataUser)
  const [user, setUser] = useState({})
  const dispatch = useDispatch()
  const [collapsed, setCollapsed] = useState(false) //nếu nhấn vào menu bán hàng thì thu gọn menu
  const [isMobile, setIsMobile] = useState(false)

  const getInfoUser = async () => {
    try {
      // const res = await apiSearch({ user_id: dataUser.data.user_id })
      // if (res.status === 200) if (res.data.data.length) setUser(res.data.data[0])
    } catch (error) {
      console.log(error)
    }
  }

  var toggle = () => {
    setCollapsed(!collapsed)
  }

  const onCollapse = (collapsed) => {
    setCollapsed({ collapsed })
  }

  const MENUS = [
    {
      title: 'Quản lý quốc gia',
      permissions: [PERMISSIONS.quan_ly_quoc_gia],
      icon: <GlobalOutlined />,
      pathsChildren: [],
      path: ROUTES.COUNTRY,
    },
    {
      title: t('layout.location_manager'),
      permissions: [PERMISSIONS.quan_ly_khu_vuc],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 384 512"
        >
          <path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" />
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.REGION,
    },
    {
      title: t('layout.branch_manager'),
      permissions: [PERMISSIONS.quan_ly_chi_nhanh],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="store"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 616 512"
          class="svg-inline--fa fa-store fa-w-20 fa-3x"
        >
          <path
            fill="currentColor"
            d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zm-70 358.2c0 2-.8 3.1-.2 3.2l-446.6.3c-.3-.2-1.2-1.3-1.2-3.5V352h448zM84 320v-64h2.5c29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.9 33.1h2.5v64zm494.2-126.5c-7.8 16.6-22.1 27.5-39.3 29.8-3.1.4-6.2.6-9.4.6-19.3 0-37-8-50-22.5L455.7 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L308 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L160.3 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5-3.2 0-6.3-.2-9.4-.6-17.2-2.3-31.5-13.2-39.3-29.8-8.7-18.6-7.5-40.8 3.3-57.9L106 32h404l64.9 103.6c10.8 17.2 12 39.3 3.3 57.9z"
            class=""
          ></path>
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.BRANCH,
    },
    {
      title: t('layout.block_order_manager'),
      permissions: [PERMISSIONS.quan_ly_block_order],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="store"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 616 512"
          class="svg-inline--fa fa-store fa-w-20 fa-3x"
        >
          <path
            fill="currentColor"
            d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zm-70 358.2c0 2-.8 3.1-.2 3.2l-446.6.3c-.3-.2-1.2-1.3-1.2-3.5V352h448zM84 320v-64h2.5c29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.9 33.1h2.5v64zm494.2-126.5c-7.8 16.6-22.1 27.5-39.3 29.8-3.1.4-6.2.6-9.4.6-19.3 0-37-8-50-22.5L455.7 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L308 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L160.3 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5-3.2 0-6.3-.2-9.4-.6-17.2-2.3-31.5-13.2-39.3-29.8-8.7-18.6-7.5-40.8 3.3-57.9L106 32h404l64.9 103.6c10.8 17.2 12 39.3 3.3 57.9z"
            class=""
          ></path>
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.BLOCK_ORDER,
    },
    {
      title: t('layout.bao_cao_booking'),
      permissions: [PERMISSIONS.bao_cao_booking],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="store"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 616 512"
          class="svg-inline--fa fa-store fa-w-20 fa-3x"
        >
          <path
            fill="currentColor"
            d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zm-70 358.2c0 2-.8 3.1-.2 3.2l-446.6.3c-.3-.2-1.2-1.3-1.2-3.5V352h448zM84 320v-64h2.5c29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.9 33.1h2.5v64zm494.2-126.5c-7.8 16.6-22.1 27.5-39.3 29.8-3.1.4-6.2.6-9.4.6-19.3 0-37-8-50-22.5L455.7 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L308 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L160.3 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5-3.2 0-6.3-.2-9.4-.6-17.2-2.3-31.5-13.2-39.3-29.8-8.7-18.6-7.5-40.8 3.3-57.9L106 32h404l64.9 103.6c10.8 17.2 12 39.3 3.3 57.9z"
            class=""
          ></path>
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.BOOKING_STATISTIC,
    },
    {
      title: t('layout.invitation_manager'),
      permissions: [PERMISSIONS.quan_ly_invitation],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="store"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 616 512"
          class="svg-inline--fa fa-store fa-w-20 fa-3x"
        >
          <path
            fill="currentColor"
            d="M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-29.6 47.2-10 110.6 38 130.8v227.4c0 19.4 14.3 35.2 32 35.2h448c17.7 0 32-15.8 32-35.2V249.4c48-20.2 67.6-83.6 38-130.8zm-70 358.2c0 2-.8 3.1-.2 3.2l-446.6.3c-.3-.2-1.2-1.3-1.2-3.5V352h448zM84 320v-64h2.5c29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.9 33.1h2.5v64zm494.2-126.5c-7.8 16.6-22.1 27.5-39.3 29.8-3.1.4-6.2.6-9.4.6-19.3 0-37-8-50-22.5L455.7 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L308 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5s-37-8-50-22.5L160.3 175l-23.8 26.6c-13 14.5-30.7 22.5-50 22.5-3.2 0-6.3-.2-9.4-.6-17.2-2.3-31.5-13.2-39.3-29.8-8.7-18.6-7.5-40.8 3.3-57.9L106 32h404l64.9 103.6c10.8 17.2 12 39.3 3.3 57.9z"
            class=""
          ></path>
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.INVITATION,
    },
    {
      pathsChildren: [],
      path: ROUTES.ORDER_LIST,
      title: t('layout.order_list'),
      permissions: [PERMISSIONS.don_hang],
      icon: <ShoppingCartOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.TABLE,
      title: t('layout.table_manager'),
      permissions: [PERMISSIONS.quan_ly_dat_ban],
      icon: <TableOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.COMMENT,
      title: 'Quản lý nhận xét',
      permissions: [PERMISSIONS.quan_ly_nhan_xet],
      icon: <AliwangwangOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.REVIEW,
      title: 'Nội dung Review',
      permissions: [],
      icon: <AliwangwangOutlined />,
    },
    {
      title: 'Quản lý set menu',
      permissions: [PERMISSIONS.quan_ly_setmenu],
      icon: <MenuOutlined />,
      pathsChildren: [],
      path: ROUTES.SETMENU,
    },
    {
      title: 'Quản lý thực đơn',
      permissions: [PERMISSIONS.quan_ly_thuc_don],
      icon: <MenuOutlined />,
      pathsChildren: [ROUTES.MENU, ROUTES.MENU_CREATE, ROUTES.MENU_UPDATE],
      path: ROUTES.MENU,
    },

    {
      pathsChildren: [ROUTES.CATEGORY],
      path: ROUTES.CATEGORIES,
      title: t('layout.category_item'),
      permissions: [PERMISSIONS.phan_loai_mon],
      icon: <SlidersOutlined />,
    },
    {
      title: 'Quản lý món ăn',
      permissions: [PERMISSIONS.quan_ly_mon_an],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path d="M96 128C96.53 128 97.07 128 97.6 128C105 91.49 137.3 64 176 64C190.1 64 204.1 68.1 216.9 75.25C230.2 49.55 257.1 32 288 32C318.9 32 345.8 49.56 359.1 75.25C371 68.1 385 64 400 64C438.7 64 470.1 91.49 478.4 128C478.9 128 479.5 128 480 128C515.3 128 544 156.7 544 192C544 203.7 540.9 214.6 535.4 224H40.56C35.12 214.6 32 203.7 32 192C32 156.7 60.65 128 96 128H96zM16 283.4C16 268.3 28.28 256 43.43 256H532.6C547.7 256 560 268.3 560 283.4C560 356.3 512.6 418.2 446.9 439.8C447.6 442.4 448 445.2 448 448C448 465.7 433.7 480 416 480H160C142.3 480 128 465.7 128 448C128 445.2 128.4 442.4 129.1 439.8C63.4 418.2 16 356.3 16 283.4H16z" />
        </svg>
      ),
      pathsChildren: [ROUTES.PRODUCT_ADD, ROUTES.PRODUCT_UPDATE],
      path: ROUTES.PRODUCT,
    },

    {
      title: 'Cách nấu',
      permissions: [PERMISSIONS.quan_ly_mon_an],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
        >
          <path d="M96 128C96.53 128 97.07 128 97.6 128C105 91.49 137.3 64 176 64C190.1 64 204.1 68.1 216.9 75.25C230.2 49.55 257.1 32 288 32C318.9 32 345.8 49.56 359.1 75.25C371 68.1 385 64 400 64C438.7 64 470.1 91.49 478.4 128C478.9 128 479.5 128 480 128C515.3 128 544 156.7 544 192C544 203.7 540.9 214.6 535.4 224H40.56C35.12 214.6 32 203.7 32 192C32 156.7 60.65 128 96 128H96zM16 283.4C16 268.3 28.28 256 43.43 256H532.6C547.7 256 560 268.3 560 283.4C560 356.3 512.6 418.2 446.9 439.8C447.6 442.4 448 445.2 448 448C448 465.7 433.7 480 416 480H160C142.3 480 128 465.7 128 448C128 445.2 128.4 442.4 129.1 439.8C63.4 418.2 16 356.3 16 283.4H16z" />
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.PRODUCT_TYPE,
    },
    {
      title: t('layout.topping'),
      permissions: [PERMISSIONS.topping],
      icon: (
        <svg
          style={{ width: 14, height: 14 }}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path d="M488.6 23.44c-31.06-31.19-81.76-31.16-112.8 .0313L24.46 374.8c-20.83 19.96-29.19 49.66-21.83 77.6c7.36 27.94 29.07 49.65 57.02 57.01c27.94 7.36 57.64-1 77.6-21.83l351.3-351.3C519.7 105.2 519.8 54.5 488.6 23.44zM438.8 118.4c-19.59 19.59-37.39 22.52-51.74 25.01c-12.97 2.246-22.33 3.867-34.68 16.22c-12.35 12.35-13.97 21.71-16.22 34.69c-2.495 14.35-5.491 32.19-25.08 51.78c-19.59 19.59-37.43 22.58-51.78 25.08C246.3 273.4 236.9 275.1 224.6 287.4c-12.35 12.35-13.97 21.71-16.22 34.68C205.9 336.4 202.9 354.3 183.3 373.9c-19.59 19.59-37.43 22.58-51.78 25.08C118.5 401.2 109.2 402.8 96.83 415.2c-6.238 6.238-16.34 6.238-22.58 0c-6.238-6.238-6.238-16.35 0-22.58c19.59-19.59 37.43-22.58 51.78-25.07c12.97-2.245 22.33-3.869 34.68-16.22c12.35-12.35 13.97-21.71 16.22-34.69c2.495-14.35 5.492-32.19 25.08-51.78s37.43-22.58 51.78-25.08c12.97-2.246 22.33-3.869 34.68-16.22s13.97-21.71 16.22-34.68c2.495-14.35 5.492-32.19 25.08-51.78c19.59-19.59 37.43-22.58 51.78-25.07c12.97-2.246 22.28-3.815 34.63-16.17c6.238-6.238 16.36-6.238 22.59 0C444.1 102.1 444.1 112.2 438.8 118.4zM32.44 321.5l290-290l-11.48-11.6c-24.95-24.95-63.75-26.57-86.58-3.743L17.1 223.4C-5.73 246.3-4.108 285.1 20.84 310L32.44 321.5zM480.6 189.5l-290 290l11.48 11.6c24.95 24.95 63.75 26.57 86.58 3.743l207.3-207.3c22.83-22.83 21.21-61.63-3.743-86.58L480.6 189.5z" />
        </svg>
      ),
      pathsChildren: [],
      path: ROUTES.TOPPING,
    },
    // {
    //   title: t('layout.supplier'),
    //   permissions: [PERMISSIONS.],
    //   icon: <UsergroupAddOutlined />,
    //   path: ROUTES.SUPPLIER,
    // },
    {
      title: t('layout.tax_administration'),
      permissions: [PERMISSIONS.quan_ly_thue],
      icon: <FileSearchOutlined />,
      pathsChildren: [],
      path: ROUTES.TAX,
    },
    {
      title: 'Phí dịch vụ',
      permissions: [PERMISSIONS.quan_ly_thue],
      icon: <DollarCircleOutlined />,
      pathsChildren: [],
      path: ROUTES.SERVICE_FEE,
    },
    {
      title: t('layout.employee_manager'),
      permissions: [PERMISSIONS.quan_ly_nhan_vien],
      icon: <UserOutlined />,
      pathsChildren: [],
      path: ROUTES.EMPLOYEE,
    },
    {
      title: 'Quản lý khách hàng',
      permissions: [PERMISSIONS.quan_ly_khach_hang],
      icon: <UsergroupAddOutlined />,
      pathsChildren: [],
      path: ROUTES.CUSTOMER,
    },
    // {
    //   title: 'Quản lý Subdomain',
    //   permissions: [PERMISSIONS.],
    //   icon: (
    //     <svg
    //       style={{ width: 14, height: 14 }}
    //       xmlns="http://www.w3.org/2000/svg"
    //       viewBox="0 0 576 512"
    //     >
    //       <path d="M565.6 36.24C572.1 40.72 576 48.11 576 56V392C576 401.1 569.8 410.9 560.5 414.4L392.5 478.4C387.4 480.4 381.7 480.5 376.4 478.8L192.5 417.5L32.54 478.4C25.17 481.2 16.88 480.2 10.38 475.8C3.882 471.3 0 463.9 0 456V120C0 110 6.15 101.1 15.46 97.57L183.5 33.57C188.6 31.6 194.3 31.48 199.6 33.23L383.5 94.52L543.5 33.57C550.8 30.76 559.1 31.76 565.6 36.24H565.6zM48 421.2L168 375.5V90.83L48 136.5V421.2zM360 137.3L216 89.3V374.7L360 422.7V137.3zM408 421.2L528 375.5V90.83L408 136.5V421.2z" />
    //     </svg>
    //   ),
    //   pathsChildren: [],
    //   path: ROUTES.DOMAIN,
    // },
    // {
    //   title: 'Quản lý bài viết',
    //   permissions: [PERMISSIONS.quan_ly_bai_viet],
    //   icon: <FolderViewOutlined />,
    //   pathsChildren: [ROUTES.BLOG, ROUTES.BLOG_UPDATE, ROUTES.BLOG_CREATE],
    //   path: ROUTES.BLOG,
    // },
    {
      title: 'Quà lưu niệm',
      permissions: [PERMISSIONS.quan_ly_qua_luu_niem],
      icon: <GiftOutlined />,
      pathsChildren: [ROUTES.SOUVENIR_ADD, ROUTES.SOUVENIR_UPDATE],
      path: ROUTES.SOUVENIR,
    },
    {
      pathsChildren: [],
      path: ROUTES.PROMOTION,
      title: 'Khuyến mãi',
      permissions: [PERMISSIONS.chuong_trinh_khuyen_mai],
      icon: <BranchesOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.GIFTCARD,
      title: 'Giftcard',
      permissions: [],
      icon: <TagOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.VOUCHER,
      title: 'Voucher mua',
      permissions: [PERMISSIONS.quan_ly_voucher_da_mua],
      icon: <TagOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.VOUCHER_GIFT,
      title: 'Voucher tặng',
      permissions: [PERMISSIONS.quan_ly_voucher_da_tang],
      icon: <TagsOutlined />,
    },
    {
      pathsChildren: [],
      path: ROUTES.PAYMENT,
      title: t('layout.payment_methods'),
      permissions: [PERMISSIONS.phuong_thuc_thanh_toan],
      icon: <CreditCardOutlined />,
    },
    {
      pathsChildren: [],
      title: 'Email quản lý',
      permissions: [PERMISSIONS.cai_dat_email_quan_ly],
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.24736 11.4542L6.97556 13.0686C6.93851 13.2893 7.02906 13.5117 7.20974 13.6434C7.39071 13.7748 7.631 13.7924 7.82871 13.6888L9.28011 12.9312L10.7315 13.6889C10.8174 13.7335 10.9115 13.7559 11.0046 13.7559C11.1265 13.7559 11.2481 13.7178 11.3508 13.6435C11.5316 13.5118 11.6224 13.2894 11.5851 13.0687L11.3136 11.4544L12.4822 10.308C12.6421 10.1514 12.699 9.91781 12.6304 9.7052C12.5616 9.49272 12.3774 9.33717 12.1562 9.30452L10.5368 9.06437L9.80739 7.59835C9.70846 7.39823 9.50351 7.27148 9.27997 7.27148C9.05685 7.27148 8.85204 7.39823 8.75226 7.59835L8.02358 9.06437L6.40414 9.30438C6.18258 9.33702 5.9992 9.49258 5.93023 9.70505C5.86125 9.91767 5.91802 10.1516 6.07812 10.3078L7.24736 11.4542Z"
            fill="#000"
          />
          <path
            d="M16.2402 1.93213H14.3859V0.903544C14.3859 0.431477 14.0032 0.0488281 13.531 0.0488281H13.3955C12.9234 0.0488281 12.5409 0.431477 12.5409 0.903544V1.93213H5.99824V0.903544C5.99824 0.431477 5.61559 0.0488281 5.14366 0.0488281H5.00798C4.53591 0.0488281 4.1534 0.431477 4.1534 0.903544V1.93213H2.32063C1.35081 1.93213 0.561523 2.72113 0.561523 3.69123V16.0048C0.561523 16.9744 1.35081 17.764 2.32063 17.764H16.2403C17.21 17.764 17.9995 16.9745 17.9995 16.0048V3.69123C17.9993 2.72113 17.2099 1.93213 16.2402 1.93213ZM16.0107 15.7753H2.55014V6.18995H16.0107V15.7753Z"
            fill="#000"
          />
        </svg>
      ),
      path: ROUTES.EMAIL_MANAGER,
    },
    {
      pathsChildren: [],
      title: 'Quản lý phân quyền',
      permissions: [PERMISSIONS.quan_ly_phan_quyen],
      icon: <PartitionOutlined />,
      path: ROUTES.ROLE,
    },
  ]

  // const renderMenuItem = (_menu) => (
  //   <Permission permissions={_menu.permissions} key={_menu.path}>
  //     {_menu.menuItems ? (
  //       <Menu.SubMenu
  //         key={_menu.path}
  //         title={
  //           <div
  //             style={{
  //               fontSize: '0.8rem',
  //               display: 'flex',
  //               flexDirection: 'column',
  //               justifyContent: 'center',
  //               alignItems: collapsed && 'center',
  //               lineHeight: '25px',
  //             }}
  //           >
  //             {collapsed && _menu.icon}
  //             {_menu.title}
  //           </div>
  //         }
  //         icon={!collapsed && _menu.icon}
  //       >
  //         {_menu.menuItems.map((e) =>
  //           !collapsed ? (
  //             <Menu.Item
  //               key={e.path}
  //               style={{
  //                 fontSize: '0.8rem',
  //                 backgroundColor: e.pathsChildren.includes(location.pathname) && '#e7e9fb',
  //               }}
  //               icon={e.icon}
  //             >
  //               <Link to={e.path}>{e.title}</Link>
  //             </Menu.Item>
  //           ) : (
  //             <Link to={e.path}>
  //               <Menu.Item
  //                 key={e.path}
  //                 style={{
  //                   fontSize: '0.8rem',
  //                   backgroundColor: e.pathsChildren.includes(location.pathname) && '#e7e9fb',
  //                   color: 'black',
  //                 }}
  //                 icon={e.icon}
  //               >
  //                 {e.title}
  //               </Menu.Item>
  //             </Link>
  //           )
  //         )}
  //       </Menu.SubMenu>
  //     ) : (
  //       <Menu.Item
  //         key={_menu.path}
  //         style={{
  //           fontSize: '0.8rem',
  //           backgroundColor: _menu.pathsChildren.includes(location.pathname) && '#e7e9fb',
  //         }}
  //         icon={_menu.icon}
  //       >
  //         <Link to={_menu.path}>{_menu.title}</Link>
  //       </Menu.Item>
  //     )}
  //   </Permission>
  // )
  const renderMenuItem = (_menu) => {
    console.log("_menu.permissions", _menu);
    return (
      <Permission permissions={_menu.permissions} key={_menu.path}>
        {_menu.menuItems ? (
          <Menu.SubMenu
            key={_menu.path}
            title={
              <div
                style={{
                  fontSize: '0.8rem',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: collapsed && 'center',
                  lineHeight: '25px',
                }}
              >
                {collapsed && _menu.icon}
                {_menu.title}
              </div>
            }
            icon={!collapsed && _menu.icon}
          >
            {_menu.menuItems.map((e) =>
              !collapsed ? (
                <Menu.Item
                  key={e.path}
                  style={{
                    fontSize: '0.8rem',
                    backgroundColor: e.pathsChildren.includes(location.pathname) && '#e7e9fb',
                  }}
                  icon={e.icon}
                >
                  <Link to={e.path}>{e.title}</Link>
                </Menu.Item>
              ) : (
                <Link to={e.path}>
                  <Menu.Item
                    key={e.path}
                    style={{
                      fontSize: '0.8rem',
                      backgroundColor: e.pathsChildren.includes(location.pathname) && '#e7e9fb',
                      color: 'black',
                    }}
                    icon={e.icon}
                  >
                    {e.title}
                  </Menu.Item>
                </Link>
              )
            )}
          </Menu.SubMenu>
        ) : (
          <Menu.Item
            key={_menu.path}
            style={{
              fontSize: '0.8rem',
              backgroundColor: _menu.pathsChildren.includes(location.pathname) && '#e7e9fb',
            }}
            icon={_menu.icon}
          >
            <Link to={_menu.path}>{_menu.title}</Link>
          </Menu.Item>
        )}
      </Permission>
    )
  }

  const ModalModifyPassword = () => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)
    const [form] = Form.useForm()

    const _resetPassword = async () => {
      try {
        await form.validateFields()
        const dataForm = form.getFieldsValue()
        if (dataForm.passwordNew !== dataForm.passwordNewAgain) {
          notification.error({ message: 'Xác nhận mật khẩu không đúng' })
          return
        }

        const body = {
          old_password: dataForm.passwordOld,
          new_password: dataForm.passwordNew,
        }
        dispatch({ type: ACTION.LOADING, data: true })

        const res = await resetPassword(dataUser?.data.customer_id, body)
        if (res.status === 200) {
          if (res.data.success) {
            toggle()
            notification.success({ message: 'Đổi mật khẩu thành công' })
          } else
            notification.error({
              message: res.data.message || 'Đổi mật khẩu thất bại, vui lòng thử lại',
            })
        } else
          notification.error({
            message: res.data.message || 'Đổi mật khẩu thất bại, vui lòng thử lại',
          })

        dispatch({ type: ACTION.LOADING, data: false })
      } catch (err) {
        dispatch({ type: ACTION.LOADING, data: false })
        console.log(err)
      }
    }

    return (
      <>
        <div onClick={toggle}>
          <div style={{ color: '#565656', paddingLeft: 10 }}>
            <LockOutlined style={{ fontSize: '1rem', marginRight: 10, color: ' #565656' }} />
            Đổi mật khẩu
          </div>
        </div>
        <Modal
          onOk={_resetPassword}
          width={550}
          okText="Xác nhận"
          cancelText="Đóng"
          visible={visible}
          onCancel={() => {
            toggle()
            form.resetFields()
          }}
          title="Đổi mật khẩu"
        >
          <Form form={form} layout="vertical">
            <Form.Item
              label="Mật khẩu cũ"
              name="passwordOld"
              rules={[{ message: 'Vui lòng nhập mật khẩu cũ', required: true }]}
            >
              <Input.Password onPressEnter={_resetPassword} placeholder="Nhập mật khẩu cũ" />
            </Form.Item>
            <Form.Item
              label="Mật khẩu mới"
              name="passwordNew"
              rules={[{ message: 'Vui lòng nhập mật khẩu mới', required: true }]}
            >
              <Input.Password onPressEnter={_resetPassword} placeholder="Nhập mật khẩu mới" />
            </Form.Item>
            <Form.Item
              label="Xác nhận khẩu mới"
              name="passwordNewAgain"
              rules={[{ message: 'Vui lòng xác nhận mật khẩu mới', required: true }]}
            >
              <Input.Password onPressEnter={_resetPassword} placeholder="Xác nhận mật khẩu mới" />
            </Form.Item>
          </Form>
        </Modal>
      </>
    )
  }

  const [key, setKey] = useState([])
  const onOpenChange = (data) => {
    localStorage.setItem('key', JSON.stringify(data))
    setKey(data)
  }

  const onSignOut = () => {
    dispatch({ type: ACTION.LOGOUT })
    dispatch({ type: 'UPDATE_INVOICE', data: [] })
  }

  useEffect(() => {
    setKey(JSON.parse(localStorage.getItem('key')))
  }, [])
  const content = (
    <div className={styles['user_information']}>
      {/* <div onClick={() => modal1VisibleModal(true)}>
        <div style={{ color: '#565656', paddingLeft: 10 }}>
          <UserOutlined style={{ fontSize: '1rem', marginRight: 10, color: ' #565656' }} />
          Tài khoản của tôi
        </div>
      </div> */}
      <ModalModifyPassword />
      <Link
        to={ROUTES.LOGIN}
        onClick={onSignOut}
        className={styles['user_information_link']}
        style={{ color: '#565656', fontWeight: '600', paddingLeft: 10 }}
      >
        <div>
          <ExportOutlined style={{ fontSize: '1rem', marginRight: 10, color: '#565656' }} />
          {t('layout.logout')}
        </div>
      </Link>
    </div>
  )
  const NotifyContent = (props) => (
    <div className={styles['notificationBox']}>
      <div className={styles['title']}>{t('layout.notification')}</div>
      <div className={styles['content']}>
        <Empty />
      </div>
    </div>
  )

  useEffect(() => {
    getInfoUser()
  }, [])

  //get width device
  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
      setCollapsed(true)
    } else setIsMobile(false)
  }, [])
  return (
    <Layout style={{ backgroundColor: 'white', height: '100%' }}>
      <BackTop style={{ right: 10, bottom: 15 }} />

      <Sider
        trigger={null}
        collapsible
        width={isMobile ? '100%' : WIDTH_MENU_OPEN}
        collapsedWidth={isMobile ? 0 : WIDTH_MENU_CLOSE}
        style={{
          backgroundColor: 'white',
          zIndex: isMobile && 6000,
          height: '100vh',
          position: 'fixed',
        }}
        collapsed={collapsed}
        onCollapse={onCollapse}
      >
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: '100%',
            display: collapsed ? 'none' : 'flex',
            maxHeight: 108,
          }}
        >
          <img
            onClick={() => history.push(ROUTES.ORDER_LIST)}
            src={logoApp}
            style={{ width: '6rem', objectFit: 'contain', marginTop: 12, cursor: 'pointer' }}
            alt=""
          />
        </div>
        <Menu
          style={{
            height: `calc(100vh - ${collapsed ? 4 : 68}px)`,
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
          theme="light"
          onOpenChange={(openKeys) => onOpenChange(openKeys)}
          openKeys={
            key
              ? key.map((values, index) => {
                  if (index === key.length - 1) {
                    return values
                  }
                })
              : ''
          }
          selectedKeys={routeMatch.path}
          mode="inline"
        >
          {MENUS.map(renderMenuItem)}
          <Menu.Item
            onClick={onSignOut}
            key="9"
            icon={<LogoutOutlined />}
            style={{ fontSize: '0.8rem' }}
          >
            <Link to={ROUTES.LOGIN}>{t('layout.logout')}</Link>
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout style={{ marginLeft: collapsed ? WIDTH_MENU_CLOSE : WIDTH_MENU_OPEN }}>
        <Affix offsetTop={0}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row wrap={isMobile} justify="space-between" className={styles['navbar']}>
                <Row
                  align="middle"
                  wrap={false}
                  style={{
                    width: '100%',
                    paddingLeft: 5,
                    paddingRight: 5,
                    marginTop: 10,
                    marginBottom: 15,
                  }}
                  justify={isMobile && 'space-between'}
                >
                  <MenuOutlined style={{ color: 'white', fontSize: 20 }} onClick={toggle} />
                </Row>
                <div className={styles['navbar_right']}>
                  <div className={styles['navbar_notification']}>
                    <DropdownLanguage />
                  </div>
                  <div className={styles['navbar_notification']}>
                    <Dropdown overlay={<NotifyContent />} placement="bottomCenter" trigger="click">
                      <Badge count={0} showZero size="small" offset={[-3, 3]}>
                        <Bell style={{ color: 'rgb(253, 170, 62)' }} />
                      </Badge>
                    </Dropdown>
                  </div>
                  <Dropdown overlay={content} trigger="click">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ padding: '0 0.75rem 0 0.5rem' }}>
                        <Avatar
                          style={{
                            color: '#FFF',
                            backgroundColor: '#FDAA3E',
                          }}
                        ></Avatar>
                      </div>
                      <div className={styles['navbar_right_left_name']}>
                        <div
                          style={{
                            color: '#FFF',
                            fontWeight: '600',
                            fontSize: '1rem',
                          }}
                        >
                          <span style={{ textTransform: 'capitalize' }}>
                            {dataUser.data &&
                              `${dataUser.data.first_name} ${dataUser.data.last_name}`}
                          </span>{' '}
                          &nbsp; <CarretDown />
                        </div>
                      </div>
                    </div>
                  </Dropdown>
                </div>
              </Row>
            </Col>
          </Row>
        </Affix>
        <Row>
          <Col
            style={{
              backgroundColor: '#f0f2f5',
              width: '100%',
              minHeight: '93vh',
              overflowY: 'auto',
            }}
          >
            {props.children}
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default BaseLayout
